import { useFileDialog } from "@vueuse/core";
import { effectScope, watch } from "vue";
import { setBuffer } from "../interop/bufferManager";
import { setImage } from "../interop/dotnetExports/bridge";

// NOTE: Duplicated from clipboard.ts
interface FileInfo {
  id: number;
  name: string;
  mimeType: string;
}

let fileTransfer: FileInfo[] | null = null;
let fileDialogNextFileBlobId = 0;
const fileDialogFileBlobs: Record<number, File | undefined> = {};

// NOTE: Duplicated from clipboard.ts
function defaultFileName(file: File): string {
  return file.type.startsWith("image/") ? "image" : "file";
}

function saveBlobsAndCreateFileResult(files: File[]): FileInfo[] {
  const filesResult: FileInfo[] = [];
  for (const file of files) {
    const fileId = fileDialogNextFileBlobId++;

    fileDialogFileBlobs[fileId] = file;

    filesResult.push({
      id: fileId,
      name: file.name || defaultFileName(file),
      mimeType: file.type,
    });
  }

  fileTransfer = filesResult;
  return filesResult;
}

// TODO: Configure to allow passing in filters correctly
// TODO: Configure to allow single/multiple files
export async function cueOpenFile(_filter: string = "image/*"): Promise<number> {
  const scope = effectScope();

  return new Promise<number>(resolve => {
    scope.run(() => {
      const { files, open } = useFileDialog({
        multiple: false,
        accept: "image/*",
        // accept: filter,
      });

      watch(files, () => {
        if ((files.value?.length ?? 0) > 0) {
          saveBlobsAndCreateFileResult(Array.from(files.value ?? []));
          resolve(0);
        } else {
          resolve(-1);
        }

        scope.stop();
      });

      open();
    });
  });
}

// TODO: Have ability to directly replace the image via id instead of relying on selection(?)
export function cueReplaceImage(id: string, isClipboard: boolean) {
  return setImage(id, isClipboard);
}

export function fileTransferTryReadFiles() {
  if (!fileTransfer) return null;
  try {
    return fileTransfer.length > 0 ? JSON.stringify(fileTransfer) : null;
  } catch (error) {
    console.error(error);
    return null;
  }
}

export function readDialogFileIntoBuffer(fileId: number): Promise<number> {
  return new Promise(resolve => {
    const file = fileDialogFileBlobs[fileId];
    if (!file) {
      // this is weird but currently there's no support for rejecting promises to map to Task.SetException
      // we return -1 as indication of error
      resolve(-1);
      return;
    }

    const reader = new FileReader();
    reader.onerror = () => {
      resolve(-1);
    };

    reader.onload = () => {
      if (reader.result instanceof ArrayBuffer) {
        const bufferId = setBuffer(reader.result);

        resolve(bufferId);
      } else {
        resolve(-1);
      }
    };

    reader.readAsArrayBuffer(file);
  });
}

export function deleteDialogFile(fileId: number) {
  delete fileDialogFileBlobs[fileId];
}
